import { render, staticRenderFns } from "./AbrFormPropReadOnly.vue?vue&type=template&id=e850e98a"
import script from "./AbrFormPropReadOnly.vue?vue&type=script&lang=js"
export * from "./AbrFormPropReadOnly.vue?vue&type=script&lang=js"
import style0 from "./AbrFormPropReadOnly.vue?vue&type=style&index=0&id=e850e98a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports